<template>
  <div class="response-detail atb-flex atb-flex-column">
    <div class="header atb-flex atb-flex-items-center">
      <div class="month-title">
        <h2 v-if="detail.year">{{ detail.year }} / {{ detail.wkName }}</h2>
        <span class="saveStatus">{{ saveStatus }}</span>
      </div>
    </div>
    <div class="container atb-content-bg atb-flex atb-flex-column">
      <div class="search-and-content atb-flex atb-flex-column" id="all">
        <div class="search">
          <div class="function atb-flex">
            <el-form :inline="true" class="atb-input">
              <el-form-item v-if="isEditable">
                <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="downloadTemplate" plain @click="exportExcel">导出</el-button>
              </el-form-item>
              <el-form-item>
                <el-button plain type="downloadTemplate" @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content atb-flex atb-flex-column kpi">
          <table class="personal-table">
            <thead>
              <tr class="label-row">
                <td width="33.3333%"><div class="personal-label">制定人</div></td>
                <td width="33.3333%"><div class="personal-label">制定日期</div></td>
                <td width="33.3333%"><div class="personal-label required-field">部门</div></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <selecter
                    v-if="isEditable"
                    class="table-field"
                    ref="formulatSelect"
                    v-model="detail.formulatNo"
                    placeholder="输入工号或姓名查询"
                    :jobNo="detail.formulatNo"
                    :name="detail.formulatName"
                    @change="formulatChange"
                  ></selecter>
                  <div v-else class="default-text">{{ detail.formulatName }}</div>
                </td>
                <td>
                  <div class="default-text" v-if="detail.formulatDate">{{ formatDate(detail.formulatDate, 'yyyy-MM-dd') }}</div>
                  <div class="default-text--disabled" v-else>提交后自动生成</div>
                </td>
                <td>
                  <DeptSelecter v-if="isEditable" :deptInfo="deptInfo" @change="deptChange" @hide="deptPopHide"></DeptSelecter>
                  <div class="default-text" v-else>{{ detail.department }}</div>
                </td>
              </tr>
              <tr class="label-row">
                <td width="33.3333%"><div class="personal-label">员工姓名</div></td>
                <td width="33.3333%"><div class="personal-label">员工工号</div></td>
                <td width="33.3333%"><div class="personal-label required-field">岗位名称</div></td>
              </tr>
              <tr>
                <td>
                  <div class="default-text">{{ detail.wkName }}</div>
                </td>
                <td>
                  <div class="default-text">{{ detail.wkNo }}</div>
                </td>
                <td>
                  <div class="table-field">
                    <el-input
                      v-if="isEditable"
                      maxlength="128"
                      v-model="detail.jobName"
                      @blur="blurField()"
                      placeholder=""
                    ></el-input>
                    <div v-else class="default-text">{{ detail.jobName }}</div>
                  </div>
                </td>
              </tr>
              <tr class="label-row">
                <td width="33.3333%"><div class="personal-label required-field">直接上级</div></td>
                <td width="66.6666%"  colspan="2"><div class="personal-label">直接下属范围</div></td>
              </tr>
              <tr>
                <td>
                  <selecter
                    v-if="isEditable"
                    ref="superiorSelect"
                    v-model="detail.superiorNo"
                    placeholder="输入工号或姓名查询"
                    :jobNo="detail.superiorNo"
                    :name="detail.superiorName"
                    @change="superiorChange"
                  ></selecter>
                  <div v-else class="default-text">{{ detail.superiorName }}</div>
                </td>
                <td colspan="2">
                  <div class="emp-range" ref="empRange" :class="{'emp-range--expand': expandRowAllFlag}">
                    <div class="float-empty" v-if="!expandRowAllFlag && isEditable"></div>
                    <div class="select-btn-wrap" v-if="!expandRowAllFlag && isEditable">
                      <span class="range-ellipse" v-if="isOverflowRange">···</span>
                    </div>
                    <el-button class="select-btn" type="primary" v-if="isEditable" size="mini" @click="showSelectSubEmp">选择</el-button>
                    <el-tag
                      v-for="(tag, index) in detail.personSubDtos"
                      :key="tag.wkNo"
                      :closable="isEditable"
                      @close="removeSubEmp(index)"
                    >
                      {{tag.wkName}}
                    </el-tag>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="detail-items">
            <DetailTable
              v-for="item in tableList"
              :key="item.workClassify"
              :tableDetail="item"
              :workId="id"
              :isEditable="isEditable"
              :saveStatus.sync="saveStatus"
              :ref="item.tableRef"
              @save="saveAll"
            ></DetailTable>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="修改"
      :visible.sync="confirmChangeVisible"
      width="420px"
      top="35vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="confirm-change-dialog"
      :before-close="changeCancel"
    >
      <span>确定要修改吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="changeCancel">取 消</el-button>
        <el-button size="small" type="primary" @click="changeConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <PersonSelecter v-if="isShowPersonSelecter" :isShowDialog.sync="isShowPersonSelecter" :dataList="detail.personSubDtos" @saveData="selectedSubEmps" />
    
  </div>
</template>
<script>
import XEUtils from 'xe-utils'
import _ from 'lodash';
import routeMixin from '@/mixins/route.mixin';
import DetailTable from './components/DetailTable.vue';
import DeptSelecter from './components/DeptSelecter.vue';
import PersonSelecter from './components/PersonSelecter.vue';
import Selecter from '@/component/global/customerSelect';

export default {
  name: 'ResponseDetail',
  inject: ['reload'],
  mixins: [routeMixin],
  components: {
    DetailTable,
    Selecter,
    DeptSelecter,
    PersonSelecter,
  },
  data() {
    return {
      tableList: [],
      id: '',
      detail: {},
      originDetail: {},
      editStatus: '',
      deptInfo: {},
      responsWorkClassifys: [],

      showSubmit: false,

      isShowPersonSelecter: false,

      approveReason: '',
      saveStatus: '',

      pending: false,
      expandRowAllFlag: false,

      status: -1,
      activeField: null,

      confirmChangeVisible: false,
      isOverflowRange: false,
    };
  },
  computed: {
    // 已保存/已驳回
    isEditable() {
      return this.editStatus === 'edit';
    },
  },

  created() {
    this.id = this.$route.query.id || '';
    this.editStatus = this.$route.query.editStatus || '';
  },
  mounted() {
    this.getResponsClassify().then(() => {
      this.getList();
    });
    window.addEventListener('resize', this.calcRangeOverflow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcRangeOverflow);
  },
  methods: {
    calcRangeOverflow() {
      this.$nextTick(() => {
        const box = this.$refs.empRange;
        if (box) {
          this.isOverflowRange = box.clientHeight < box.scrollHeight;
        }
      });
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    getResponsClassify() {
      return this.$ajax.get(this.$api.common.getDict, { ItemType: 'ResponsWorkClassify' }).then((res) => {
        this.responsWorkClassifys = res.data.rows || [];
      });
    },

    getList() {
      let param = { id: this.id };
      this.$ajax.get(this.$api.responsWork.detail.getWorkDetail, param).then((res) => {
        //判断审批状态下是否所有工作项内容都已审批过
        const result = res.data.data.entityWork.details || [];
        this.detail = res.data.data.entityWork.work;
        // 如果extend中存在分类数据，优先使用此数据
        const extendData = this.detail.extend ? JSON.parse(this.detail.extend) : [];
        let extendWorkClassifys = [];
        const extendWorkClassifyItem = extendData.find(item => item.ItemType === "ResponsWorkClassify");
        if (extendWorkClassifyItem) {
            extendWorkClassifys = extendWorkClassifyItem.ExtendPairs || [];
            extendWorkClassifys.forEach(item => {
              item.itemKey = item.itemKey || item.ItemKey;
              item.itemDesc = item.itemDesc || item.ItemDesc;
              item.itemValue = item.itemValue || item.ItemValue;
              item.itemGroup = item.itemGroup || item.ItemGroup;
            });
            extendWorkClassifys.sort((a, b) => a.itemKey - b.itemKey);
        }
        const workClassifyList = extendWorkClassifys && extendWorkClassifys.length > 0 ? extendWorkClassifys : this.responsWorkClassifys;
        const tableList = [];
        workClassifyList.forEach(item => {
          tableList.push({
            headerTitle: item.itemDesc,
            workClassify: item.itemKey,
            typeText: item.itemGroup,
            weight: item.itemValue,
            tableData: [],
            tableRef: `tableRef${item.itemKey}`
          });
        });
        this.tableList = tableList;

        let directReports = this.detail.directReports ? JSON.parse(this.detail.directReports) : {};
        let personSubDtos = directReports.Content || '[]';
        personSubDtos = JSON.parse(personSubDtos);
        personSubDtos = personSubDtos.map(item => {
          return {
            wkName: item.WkName,
            wkNo: item.WkNo,
          }
        });
        this.detail.personSubDtos = personSubDtos;
        this.status = this.detail.status;

        this.deptInfo = {
          department: this.detail.department,
          departmentNo: this.detail.departmentNo,
        };

        result.forEach(item => item.expandRowFlag = false)
        this.tableList.forEach(tableItem => {
          tableItem.tableData = result.filter(item => tableItem.workClassify == item.workClassify);
        });

        this.originDetail = _.cloneDeep(this.detail);
        this.calcRangeOverflow()
      });
    },
  
    expandRowAll() {
      this.expandRowAllFlag = !this.expandRowAllFlag;
      if (this.expandRowAllFlag) {
        for (let i = 0; i < this.tableList.length; i++) {
          const tb = this.tableList[i];
          this.$refs[tb.tableRef][0].openAllRow();
        }
      } else {
        for (let i = 0; i < this.tableList.length; i++) {
          const tb = this.tableList[i];
          this.$refs[tb.tableRef][0].closeAllRow();
        }
      }
    },
    
    openAllTable() {
      for (let i = 0; i < this.tableList.length; i++) {
        const tb = this.tableList[i];
        this.$refs[tb.tableRef][0].openTable();
      }
    },

    removeSubEmp(index) {
      this.detail.personSubDtos.splice(index, 1);
      this.$forceUpdate();
      this.saveEditBefore();
      this.calcRangeOverflow();
    },
    showSelectSubEmp() {
      this.isShowPersonSelecter = true;
    },
    selectedSubEmps(list) {
      this.detail.personSubDtos = list;
      this.isShowPersonSelecter = false;
      if (JSON.stringify(this.detail.personSubDtos) === JSON.stringify(this.originDetail.personSubDtos)) return 1;
      this.saveEditBefore();
      this.calcRangeOverflow();
    },
    deptChange({department, departmentNo}) {
      this.detail.department = department;
      this.detail.departmentNo = departmentNo;
    },
    deptPopHide() {
      if (this.detail.departmentNo === this.originDetail.departmentNo) return 1;
      this.saveEditBefore();
    },
    formulatChange() {
      this.detail.formulatName = this.$refs.formulatSelect.currentOption.name;
      if (this.detail.formulatNo === this.originDetail.formulatNo) return 1;
      this.saveEditBefore();
    },
    superiorChange() {
      this.detail.superiorName = this.$refs.superiorSelect.currentOption.name;
      if (this.detail.superiorName === this.originDetail.superiorName) return 1;
      this.saveEditBefore();
    },
    getAllTableData() {
      //获取所有工作项的数据
      let allTableData = [];
      this.tableList.forEach(item => {
        allTableData = allTableData.concat(this.$refs[item.tableRef][0].getTableData());
      });
      return allTableData;
    },
    blurFn() {
      this.$refs.headerRef.click();
    },
    changeCancel() {
      this.confirmChangeVisible = false;
      this.detail = _.cloneDeep(this.originDetail);
      this.deptInfo = {
        department: this.detail.department,
        departmentNo: this.detail.departmentNo,
      }
    },
    changeConfirm() {
      this.confirmChangeVisible = false;
      this.saveAll();
    },
    saveEditBefore() {
      this.confirmChangeVisible = true;
    },
    saveAll() {
      if (this.pending) return 0;
      this.pending = true;
      let arr = this.getAllTableData();
      this.detail.jobName = this.$filterSpecialChars(this.detail.jobName);
      const params = {
        ...this.detail,
        personSubDtos: this.detail.personSubDtos,
        responseDetailUpdateDtos: arr,
      }
      this.$ajax.post(this.$api.responsWork.manage.detailSave, params, { noLoading: true }).then(() => {
        this.$message.success('保存成功');
        this.originDetail = _.cloneDeep(this.detail);
      }).finally(() => {
        this.pending = false;
      });
    },
    
    blurField() {
      if (this.detail.jobName === this.originDetail.jobName) return;
      this.saveEditBefore();
    },

    
    exportExcel() {
      let param = { id: this.id };

      let apiURL = this.$api.responsWork.detail.exportFile;
      this.$ajax.get(apiURL, param, { ignore: true, responseType: 'blob' }).then((res) => {
        if (res.data.type == 'application/json') {
          var reader = new FileReader();
          reader.onload = () => {
            var content = reader.result; //内容就在这里
            let json = JSON.parse(content);
            this.$message.error(json.message);
          };
          reader.readAsText(res.data);
        } else {
          const filename = `${this.detail.wkName}${this.detail.year}年岗位职责表`;
          const filetype = 'docx';
          let data = res.data;
          let url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename + '.' + filetype;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.response-detail {
  color: #555;
  height: 100%;
  .header {
    margin-top: -5px;
    .month-title {
      padding: 0 10px;
      line-height: 30px;
      h2 {
        color: $--color-text-primary;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
      }
      .saveStatus {
        margin-left: 10px;
        font-size: 15px;
        color: #8e9694;
      }
    }
    
  }
  .container {
    margin-top: 15px;
    padding: 20px;
    flex: 1;
    .el-form-item {
      margin-bottom: 12px;
    }
    .search-and-content {
      flex: 1;
      overflow: auto;
      .search {
        .function {
          flex-wrap: wrap;
        }
      }
    }

  }
  ::v-deep .el-dialog__footer {
    text-align: right;
  }
  ::v-deep .el-input-group__append {
    padding: 0 5px;
  }
}

.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}

.personal-table {
  border-collapse: collapse;
  font-size: 14px;
  .label-row {
    background-color: #f6f7fb;
  }

  td {
    padding: 5px 10px;
    border: 1px solid #dcdfe6;
  }
  .personal-label {
    padding: 8px 0;
    color: $--color-primary;
  }
  .table-field, .el-select {
    width: 100%;
  }
  .emp-range {
    position: relative;
    height: 72px;
    min-height: 72px;
    overflow: hidden;
    &.emp-range--expand {
      height: auto;
    }
    .float-empty {
      float: right;
      height: 43px;
      width: 2px;
    }
    .range-ellipse {
      margin-right: 18px;
    }
    .select-btn-wrap {
      margin-top: 4px;
      float: right;
      clear: both;
    }
    .select-btn {
      margin-right: 8px;
      padding: 6px 15px;
    }
    .el-tag {
      margin: 4px 8px 4px 0;
    }
  }
  .default-text {
    height: 36px;
    display: flex;
    align-items: center;
  }
  .default-text--disabled {
    color: #8e9694;
  }
  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: #555;
  }
  ::v-deep .el-input.is-disabled .el-input__inner {
    color: #555;
  }
}
::v-deep .confirm-change-dialog .el-dialog {
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 4px;
  .el-dialog__header {
    .el-dialog__title {
      color: #555;
    }
    background-color: #fff;
  }
  .el-dialog__headerbtn .el-dialog__close, .el-dialog__headerbtn:hover {
    color: #909399!important;
  }
  .el-dialog__body {
    padding: 10px 15px!important;
  }
}
.required-field {
  &::before {
    content: '*';
    color: #f56c6c;
    font-size: 14px;
    padding-right: 4px;
    font-family: Verdana, Arial, Tahoma;
    vertical-align: -2px;
  }
}
::v-deep .footer-center .el-dialog__footer {
  text-align: center;
}
</style>